package com.picme.sdk2

import com.lightningkite.kiteui.FileReference
import com.picme.sdk2.UploadImageInfo

actual class BackgroundUploadManager actual constructor() {
    actual fun startBackgroundUploadRequest(uploadInfo: UploadImageInfo, file: FileReference) {
        return
    }
}